import React, {Component} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import SAInputComponent from "../common/input/SAInputComponent";
import {Divider} from "antd";
import ActiveDateSelect from "./ActiveDateSelect";
import {connect} from "react-redux";
import {MEDIA_BACKGROUND} from "./MediaType";
import Constants from "../../services/Constants";
import UploadPictures from "../common/upload/UploadPictures";
import {SpinnerModal} from "../../public/components/SpinnerModal";

class BackgroundConfiguration extends Component {

  constructor(props) {
    super(props);
    this.state = {
      background: {
        active: false,
        type: MEDIA_BACKGROUND,
        media:{

        }
      },
      pristine: false
    };
  }

  componentDidMount() {
    this.props.dispatchFetchBackground();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.background) {
      this.setState({background:{...nextProps.background}});
    }
  }

  onSave = () => {
    const {background} = this.state;
    this.props.dispatchUpdateBackground({
      ...background,
      media:{
        ...background.media,
        smartphone: background.media.smartphone && background.media.smartphone.key,
        tablet: background.media.tablet && background.media.tablet.key
      }
    });
  };

  onPropertyUpdate = (property, data) => {
    this.setState({[property]: data, pristine: true})
  };

  onBackgroundDelete = (picture, metadata) => {
    this.props.dispatchDeletePicture({key: picture.key, metadata});
    this.setState({pristine: true})
  };

  onBackgroundUpload = (file, metadata) => {
    const key = `public/${metadata.key}`;
    this.props.dispatchUploadPicture({key, file, metadata});
    this.setState({pristine: true})
    return false;
  };

  render() {
    const {intl: {formatMessage}, loading, errors = {}} = this.props;
    const {background = {}, pristine} = this.state;

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            <FormattedMessage id="section.communication.background-configuration"/>
          </h2>
          <div className="box-heading__button">
            <button type="primary" disabled={!pristine} className="btn btn-sm btn-primary" onClick={() => this.onSave()}>
              <FormattedMessage id="action.save"/>
            </button>
          </div>
        </header>

        <div className="box__body">
          <SpinnerModal visible={loading}/>
          <ActiveDateSelect data={background} errors={errors} onChange={data => this.onPropertyUpdate("background", data)}/>
          <Divider/>

            <div className="row">
              <div className="col-md-12 col-xxl-12">
                <h3 className="box__subtitle"><FormattedMessage id="communication.background"/></h3>
                <div className="row">
                  <div className="col-md-6 col-xxl-6">
                    <SAInputComponent label={formatMessage({id: 'communication.smartphone'})} error={errors['media'] || errors['media.smartphone']}>
                      <UploadPictures allowUpload={(background.media.smartphone || []).length < 1} error={errors.smartphone}
                                  category="background/smartphone" accept={Constants.ALLOWED_IMAGE_TYPE}
                                  files={background.media.smartphone && [background.media.smartphone]}
                                  beforeUpload={file => this.onBackgroundUpload(file, {device:'smartphone', key:`background/smartphone`})}
                                  onRemove={() => this.onBackgroundDelete(background.media.smartphone, {device:'smartphone', key:"background/smartphone"})}/>
                    </SAInputComponent>
                  </div>
                  <div className="col-md-6 col-xxl-6">
                    <SAInputComponent label={formatMessage({id: 'communication.tablet'})} error={errors['media'] || errors['media.tablet']}>
                      <UploadPictures allowUpload={(background.media.tablet || []).length < 1} error={errors.tablet}
                                  category="background/tablet" accept={Constants.ALLOWED_IMAGE_TYPE}
                                  files={background.media.tablet && [background.media.tablet]}
                                  beforeUpload={file => this.onBackgroundUpload(file, {device:'tablet', key:`background/tablet`})}
                                  onRemove={() => this.onBackgroundDelete(background.media.tablet, {device:'tablet', key:"background/tablet"})}/>
                    </SAInputComponent>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  background: state.fetchNscBackground && state.fetchNscBackground.body,
  loading: state.fetchNscBackground.loading,
  errors: (state.fetchNscBackground.error || {}).content
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchBackground: () => dispatch({type: 'FETCH.COMMUNICATION_BACKGROUND.REQUEST'}),
  dispatchUpdateBackground: body => dispatch({type: 'SAVE.COMMUNICATION_BACKGROUND.REQUEST', body}),
  dispatchUploadPicture: payload => dispatch({type: 'SAVE.COMMUNICATION_BACKGROUND_FILE.REQUEST', payload}),
  dispatchDeletePicture: payload => dispatch({type: 'DELETE.COMMUNICATION_BACKGROUND_FILE.REQUEST', payload})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(BackgroundConfiguration));



// WEBPACK FOOTER //
// ./src/components/communication/BackgroundConfiguration.js